module.exports = __webpack_public_path__ + "img/gb5783.prt.42004532.jpg";